/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import { Button, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { format, isPast, parse } from 'date-fns';
import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react';
import Snack from '../components/Snack';
import Main from '../container/Main';
import getClientesBoletos from '../services/clientesBoletos';
import getGerarBoleto from '../services/gerarBoletos';
import translation from '../utils/tableTranslation';

const BoletosList = () => {
  const [clienteAtual, setClienteAtual] = useState('');
  const [boletos, setBoletos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [isTypeShow, setIsTypeShow] = useState(false);
  const [rowDataAtual, setRowDataAtual] = useState();

  useEffect(() => {
    setLoading(true);
    getClientesBoletos({ cpf: localStorage.getItem('cpfCliente'), titulo: localStorage.getItem('tituloCliente') })
      .then((res) => {
        setBoletos(res.data.data);
        if (res.data.data[0]) {
          setClienteAtual(res.data.data[0].NOME);
        }
      })
      .catch(() => {
        setSnackOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const closeDialog = () => {
    setIsClose(true);
    setShowDialog(false);
  };

  const downloadResponse = (response) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(response.data, 'boleto.pdf');
    } else {
      const blob = new Blob([response.data], { type: response.data.type });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const fileName = 'boleto.pdf';
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  };

  const selectTable = (rowData) => {
    getGerarBoleto(rowData.codBar)
      .then((response) => {
        downloadResponse(response);
      })
      .catch(() => {
        setSnackOpen(true);
      });
  };

  const generateMultiplePDF = () => {
    getGerarBoleto(selectedRows.map((row) => row.codBar).join(','))
      .then((response) => {
        downloadResponse(response);
      })
      .catch(() => {
        setSnackOpen(true);
      });
  };

  const viewPDF = (rowData) => {
    getGerarBoleto(rowData.codBar)
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const fr = new FileReader();
        fr.readAsDataURL(blob);
        fr.onload = () => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'boleto.pdf');
          } else {
            const win = window.open();
            win.document.write(`<iframe src="${fr.result}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`);
          }
        };
      })
      .catch(() => {
        setSnackOpen(true);
      });
  };

  const continuar = () => {
    if (isTypeShow) {
      viewPDF(rowDataAtual);
    } else {
      selectTable(rowDataAtual);
    }
    closeDialog();
  };

  const openSiteSicoob = () => {
    continuar();
    window.open('https://www.sicoob.com.br/segunda-via-de-boleto');
  };

  // eslint-disable-next-line no-unused-vars
  const checarSeEstaVencido = (rowData, isShow) => {
    setIsTypeShow(isShow);
    setRowDataAtual(rowData);
    if (isPast(parse(format(parse(rowData.dataVencimento, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', new Date()), 'yyyy-MM-dd\'T\'23:59:59.999\'Z\''), 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', new Date()))) {
      setShowDialog(true);
    } else {
      setIsClose(false);
      setShowDialog(false);
      if (isShow) {
        viewPDF(rowData);
      } else {
        selectTable(rowData);
      }
    }
  };

  const openOnlySicoob = () => {
    window.open('https://www.sicoob.com.br/segunda-via-de-boleto');
  };

  useEffect(() => {
    if (rowDataAtual !== undefined && !showDialog && !isClose) {
      continuar();
    }
  }, [showDialog]);


  return (
    <Main>
      <Typography variant="h5" style={{ marginBottom: 25, paddingTop: 15 }}>
        {clienteAtual ? `Cliente: ${clienteAtual}` : ''}
      </Typography>
      <Grid container justify="space-between" style={{ marginTop: 10, marginBottom: 10 }}>
        <Grid item>
          <Button variant="contained" color="primary" disabled={selectedRows.length === 0} onClick={generateMultiplePDF}>Gerar Boleto</Button>
        </Grid>
        <Grid item>
          <Button variant="contained" color="secondary" onClick={openOnlySicoob}>Acessar o site da Sicoob para atualizar seu boleto vencido</Button>
        </Grid>
      </Grid>
      <MaterialTable
        isLoading={loading}
        columns={[
          { title: 'Nosso número', field: 'codBar' },
          { title: 'Data Vencimento', field: 'dataVencimento', render: (rowData) => format(parse(rowData.dataVencimento, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', new Date()), 'dd/MM/yyyy') },
          { title: 'Valor', field: 'somaValores', render: (rowData) => rowData.somaValores.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) },
          // { title: 'Visualizar', field: 'codBar', render: (rowData) => (<Button color="primary" onClick={() => { viewPDF(rowData); }}>Visualizar</Button>) },
          // { title: 'Baixar', field: 'codBar', render: (rowData) => (<Button color="secondary" onClick={() => { selectTable(rowData); }}>Baixar</Button>) },
          // { title: 'Visualizar', field: 'codBar', render: (rowData) => (<Button color="primary" onClick={() => { checarSeEstaVencido(rowData, true); }}>Visualizar</Button>) },
          // { title: 'Baixar', field: 'codBar', render: (rowData) => (<Button color="secondary" onClick={() => { checarSeEstaVencido(rowData, false); }}>Baixar</Button>) },
        ]}
        // onRowClick={(e, rowData) => selectTable(rowData)}
        data={boletos}
        options={{
          toolbar: false,
          selection: true,
          pageSize: 10,
          // rowStyle: (rowData) => ({
          //   backgroundColor: (rowData.status === 'I') ? '#EF9A9A' : '#FFF',
          // }),
        }}
        localization={translation}
        onSelectionChange={(rows) => { setSelectedRows(rows); }}
      />
      <Snack
        variant="error"
        message="Falha ao recuperar o(s) boleto(s)"
        open={snackOpen}
        setOpen={(open) => setSnackOpen(open)}
      />
      <Dialog open={showDialog} onClose={closeDialog}>
        <DialogTitle id="alert-dialog-title">Boleto Vencido</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Este Boleto se encontra vencido, clique em atualizar boleto para ir ao site gerar uma nova via, ou clique em continuar caso deseje apenas continuar sem ser redirecionado.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={openSiteSicoob} color="primary">
            Atualizar Boleto
          </Button>
          <Button onClick={continuar} color="primary" autoFocus>
            Continuar
          </Button>
        </DialogActions>
      </Dialog>
    </Main>
  );
};

export default BoletosList;
